import { render } from "./ExamAttemptsReport.vue?vue&type=template&id=deeac6a0&scoped=true"
import script from "./ExamAttemptsReport.vue?vue&type=script&lang=js"
export * from "./ExamAttemptsReport.vue?vue&type=script&lang=js"

import "./ExamAttemptsReport.vue?vue&type=style&index=0&id=deeac6a0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-deeac6a0"]])

export default __exports__